import React from 'react'
import s from './RouteMainInformations.less'
import RouteLabelComponents from './RouteLabelComponents'

const RouteMainInformationsLabels = ({ labels }) => (
  <>
    {labels.map((label, idx) => (
      <div key={idx} className={s.label}>
        <RouteLabelComponents components={label} />
      </div>
    ))}
  </>
)

export default RouteMainInformationsLabels
